<template>
  <div>
    <div>
      <ul class="tabs">
        <div
          v-for="(tab, i) in tabs"
          :key="i"
          class="tab"
          :class="{ 'is-tab-selected': activeIndex === i }"
        >
          <h3 class="tab-name">{{ tab.name }}</h3>
        </div>
      </ul>
    </div>

    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return { tabs: [] };
  },
  created() {
    this.tabs = this.$children;
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";

.tabs {
  /**
     * Setting display to flex makes this container lay
     * out its children using flexbox, the exact same
     * as in the above "Stepper input" example.
     */
  display: flex;
  justify-content: center;
  padding: 0;
  border-bottom: 1px solid transparentize($color-black, 0.8);
}
.tab {
  padding: 5px 30px;
  font-size: 12px;
  border-bottom: 2px solid transparent;
}
.tab > * {
  color: transparentize($color-black, 0.5);
}
.tab.is-tab-selected {
  border-bottom-color: $color-primary;
}
.tab.is-tab-selected > * {
  color: $color-primary;
}
.tab-name {
  margin: 5px 0;
}
</style>
